/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Card,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Loading } from '../../../../helpers/utils';
import NewExam from './NewExam';
import ExamsList from './ExamsList';

import groupServices from '../../../../redux/services/groupServices';
import semesterServices from '../../../../redux/services/semesterServices';
import companyServices from '../../../../redux/services/companyServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
}));

const Exams = ({ company }) => {
  const [examData, setExamData] = useState([]);
  const [semestersList, setSemestersList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    semesterServices.getAllSemesters()
      .then((allSemesters) => {
        const semesterArr = [];
        allSemesters.forEach((sem) => {
          if (sem.value > 0 && sem.value < 7 && sem.schoolTypes.includes(type)) {
            semesterArr.push(sem);
          }
        });
        semesterArr.sort((a, b) => a.value - b.value);
        const tmp = [];
        semesterArr.forEach((sem) => {
          if (!sem.catchUp) {
            tmp.push(sem);
          }
        });
        setSemestersList(tmp);
      });
  }, [type]);

  const updateExamData = () => {
    groupServices.getGroupsDataByCompagny(company._id)
      .then((res) => {
        const tmp = [];
        setGroups(res);
        if (res.data) {
          const groupArr = Object.values(res.data);
          groupArr.forEach((group) => {
            if (group.elearning
              && group.elearning.elearningOptions
              && group.elearning.elearningOptions.length > 0
              && group.level === 1) {
              group.elearning.elearningOptions.forEach((option) => {
                tmp.push({ ...option, semester: group.semester });
              });
            }
          });
        }
        setExamData(tmp);
        setLoading(false);
      });
  };

  useEffect(() => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setType(res.adminData.type);
        updateExamData();
      });
  }, []);

  return (
    <>
      {loading === false
        ? (
          <Card className={classes.root}>
            <NewExam
              companyId={company._id}
              examData={examData}
              setExamData={setExamData}
              semestersList={semestersList}
              updateExamData={updateExamData}
            />
            <ExamsList
              companyId={company._id}
              examData={examData}
              setExamData={setExamData}
              groups={groups}
              semestersList={semestersList}
              updateExamData={updateExamData}
            />
          </Card>
        )
        : <Loading />}
    </>
  );
};

Exams.propTypes = {
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedExams = connect(mapState, null)(Exams);

export default withRouter(connectedExams);
